import { GridViewIcon, Unlink01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button, Typography, Box, Card } from "@mui/material";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f6f8fc 0%, #edf1f9 100%)",
        position: "relative",
        overflow: "hidden",
        p: 3,
      }}
    >
      {/* Decorative Floating Shape 1: Top Right Squircle (Viewport level) */}
      <Box
        sx={{
          position: "absolute",
          top: "12%",
          right: "12%",
          width: 140,
          height: 140,
          borderRadius: "36px",
          background: "rgba(1, 95, 238, 0.04)",
          transform: "rotate(15deg)",
          pointerEvents: "none",
          zIndex: 0,
          display: { xs: "none", sm: "block" },
        }}
      />

      {/* Decorative Floating Shape 2: Bottom Left Circle Outline (Viewport level) */}
      <Box
        sx={{
          position: "absolute",
          bottom: "12%",
          left: "12%",
          width: 80,
          height: 80,
          borderRadius: "50%",
          border: "2px solid rgba(1, 95, 238, 0.05)",
          pointerEvents: "none",
          zIndex: 0,
          display: { xs: "none", sm: "block" },
        }}
      />

      {/* Main Card Container */}
      <Card
        elevation={0}
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 500,
          borderRadius: "24px",
          backgroundColor: "#ffffff",
          boxShadow: "0 20px 50px rgba(7, 21, 78, 0.05)",
          p: { xs: 4, md: 6 },
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Floating shape elements overlapping card corners to match reference image */}
        {/* Top-Right overlapping squircle */}
        <Box
          sx={{
            position: "absolute",
            top: -24,
            right: -24,
            width: 72,
            height: 72,
            borderRadius: "18px",
            background: "linear-gradient(135deg, rgba(1, 95, 238, 0.1) 0%, rgba(1, 95, 238, 0.02) 100%)",
            transform: "rotate(12deg)",
            pointerEvents: "none",
            zIndex: -1,
          }}
        />

        {/* Bottom-Left overlapping circle outline */}
        <Box
          sx={{
            position: "absolute",
            bottom: "25%",
            left: -20,
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "2px solid rgba(1, 95, 238, 0.12)",
            pointerEvents: "none",
            zIndex: -1,
          }}
        />

        {/* Circular Icon Container */}
        <Box
          sx={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            backgroundColor: "#eaebee",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <HugeiconsIcon icon={Unlink01Icon} size={36} color="#015FEE" strokeWidth={1.75} />
        </Box>

        {/* 404 Text */}
        <Typography
          sx={{
            fontSize: { xs: "5.5rem", md: "7rem" },
            fontWeight: 800,
            color: "darkBlue.main",
            lineHeight: 0.9,
            letterSpacing: "-0.02em",
            mb: 1.5,
          }}
        >
          404
        </Typography>

        {/* Horizontal Divider Line */}
        <Box
          sx={{
            width: 44,
            height: 4,
            backgroundColor: "#015FEE",
            borderRadius: "2px",
            mb: 3.5,
          }}
        />

        {/* Heading */}
        <Typography
          sx={{
            fontSize: { xs: "1.35rem", md: "1.5rem" },
            fontWeight: 700,
            color: "darkBlue.main",
            lineHeight: 1.3,
            mb: 1.5,
          }}
        >
          ¡Ups! La página que buscas no existe.
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: "0.925rem",
            color: "#475467",
            lineHeight: 1.6,
            fontWeight: 300,
            mb: 4.5,
            maxWidth: 380,
            whiteSpace: "pre-line",
          }}
        >
          Parece que el enlace está roto o la página ha sido movida.{"\n"}
          No te preocupes, tus datos de gestión están seguros.
        </Typography>

        {/* Action Button */}
        <Button
          component={Link}
          to="/comercios"
          variant="contained"
          startIcon={<HugeiconsIcon icon={GridViewIcon} size={18} />}
          sx={{
            backgroundColor: "#015FEE",
            color: "#ffffff",
            borderRadius: "10px",
            py: 1.5,
            px: 3.5,
            fontSize: "0.95rem",
            fontWeight: 500,
            textTransform: "none",
            boxShadow: "0 8px 20px rgba(1, 95, 238, 0.15)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#0052cc",
              boxShadow: "0 10px 24px rgba(1, 95, 238, 0.25)",
              transform: "translateY(-1px)",
            },
            "&:active": {
              transform: "translateY(0)",
            },
          }}
        >
          Volver al inicio
        </Button>
      </Card>
    </Box>
  );
};

export default NotFoundPage;

